import React, {createContext, ReactNode, useContext} from 'react';


interface ComponentContextType {
    cmId: string;
}

interface Props {
    children: ReactNode;
    id: string;
}

export const ParentComponentContext = createContext<ComponentContextType>({} as ComponentContextType);
const useParentComponentContext = () => useContext(ParentComponentContext);

const ParentComponentProvider = (props: Props) => {
    return <ParentComponentContext.Provider value={{cmId: props.id}}>
        {props.children}
    </ParentComponentContext.Provider>;
};

export {useParentComponentContext, ParentComponentProvider};